<router-outlet></router-outlet>
<ng-toast></ng-toast>
<app-version *ngIf="!isAdminRoute" class="app-version--fixed"></app-version>
